import React from 'react'

function Loader() {
    return (
        <div>
            <div className="w-16 h-16 border-4 border-blue-400 border-dotted rounded-full border-t-transparent animate-spin"></div>
        </div>
    )
}

export default Loader